import { useState, useLayoutEffect, useEffect, useCallback } from "react";

export const useDropdownDirection = (
  open: boolean,
  triggerRef: React.RefObject<HTMLElement>,
  dropdownRef: React.RefObject<HTMLElement>
) => {
  const [direction, setDirection] = useState<"left" | "right">("right");
  const [ready, setReady] = useState(false);

  const measureDirection = useCallback(() => {
    if (triggerRef.current && dropdownRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const dropdownRect = dropdownRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      const spaceRight = viewportWidth - triggerRect.left;

      if (spaceRight < dropdownRect.width) {
        setDirection("left");
      } else {
        setDirection("right");
      }

      setReady(true);
    }
  }, [triggerRef, dropdownRef]);

  useLayoutEffect(() => {
    if (open) {
      measureDirection();
    } else {
      setReady(false);
    }
  }, [open, measureDirection]);

  useEffect(() => {
    if (!open) return;

    const handleResize = () => {
      measureDirection();
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [open, measureDirection]);

  return { direction, ready };
};
